// import React from "react";
import { useEffect } from "react";

import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

import $ from "jquery";

// innerPageUi - CSS
import "../../../assets/globalVar.css";
import "../../../assets/style.css";
import "../../../assets/custom.css";
import "../../../assets/styledev.css";
import "../../../assets/modes.css";

// v3
import './App.css';
import '../../../assets/v3/fonts/font.css';
import '../../../assets/v3/styles/Common.scss';

import NavbarMenu from './NavbarMenu';

export default function NavbarOne(props) {

  const location = useLocation();
  // const { pathname } = useLocation();
  // const currentPage = pathname;

  useEffect(() => {
    console.log("Page changed to:", location.pathname);
    if(location.pathname == "/") {
      $('body').addClass("homepage");
    }
    else {
      $('body').removeClass("homepage");
    }
  }, [location]);

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 60) {
      $('.bg-nav').addClass("fixed");
      $('#header_menu').addClass("fixed");
    } else {
      $('#header_menu').removeClass("fixed");
    }
  });

  return (
    <NavbarMenu
      setTheme={props.setTheme}
      theme={props.theme}
      identify={props.identify}
    />
  )
}